import { useBreakpointValue } from "@chakra-ui/react";

/**
 * a hook that check if the view is mobile or not
 */
const useIsMobile = (): boolean => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return !!isMobile;
};

export default useIsMobile;
